import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Box, Breadcrumbs, Button, Typography } from '@mui/material'
import { ArrowBack, Circle } from '@mui/icons-material'
import Main from '@/views/layouts/main'

import ErrorLimit from '@/views/components/error-limit/index.component'
import FreePlayContributionsModule from '@/views/contributions/index.module'
import PageTitle from '@/views/layouts/page-title/index.layout'

import routes from '@/routes'

const ContributionsPage = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const handleBack = () => {
    navigate(routes.wallets.INDEX)
  }

  const breadcrumbs = (
    <Breadcrumbs separator={<Circle sx={{ fontSize: 6, marginX: 2 }} />}>
      <Link to={routes.HOME}>
        <Typography>{t('pages.home')}</Typography>
      </Link>
      <Typography>{t('pages.bonusEngine')}</Typography>
      <Link to={routes.wallets.INDEX}>
        <Typography>{t('pages.wallet')}</Typography>
      </Link>
      <Typography>{t('pages.freePlayContributions')}</Typography>
    </Breadcrumbs>
  )

  return (
    <Main>
      <ErrorLimit>
        <Box display="flex" mb={5}>
          <PageTitle
            title={t('pages.listContributions')}
            breadcrumbs={breadcrumbs}
          />
          <Box display="flex" alignItems="center" flexShrink={0}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleBack}
              startIcon={<ArrowBack />}
            >
              {t('pages.bonus')}
            </Button>
          </Box>
        </Box>
        <FreePlayContributionsModule />
      </ErrorLimit>
    </Main>
  )
}

export default ContributionsPage
